import { createFileRoute } from '@tanstack/react-router'
import AuthCallback from '@/pages/auth/call-back'

export const Route = createFileRoute('/_auth/auth/callback/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <AuthCallback />
}
